import { useAuth0 } from '@auth0/auth0-react';
import { IconLogout } from '@tabler/icons-react';

export const LogoutButton = ({ color = 'inherit' }: { color?: string }) => {
  const { logout } = useAuth0();

  return (
    <button
      type="button"
      onClick={() =>
        logout({ logoutParams: { returnTo: window.location.origin } })
      }
      aria-label="logout"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        padding: 0,
        border: 'none',
        borderRadius: 8,
        background: 'transparent',
        color,
        cursor: 'pointer',
      }}
    >
      <IconLogout size={20} />
    </button>
  );
};
